import { Select as SelectPrimitive } from '@base-ui/react/select';
import { Check, ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
export interface Option {
    value: string;
    label: string;
    disabled?: boolean;
}
export function Select({ value, onChange, options, label, disabled = false, className, id }: {
    value: string;
    onChange: (value: string) => void;
    options: Option[];
    label: string;
    disabled?: boolean;
    className?: string;
    id?: string;
}) {
    return <SelectPrimitive.Root items={options} value={value} onValueChange={next => {
            if (next !== null)
                onChange(next);
        }} disabled={disabled}>
  <SelectPrimitive.Trigger id={id} className={cn('select-trigger', className)} aria-label={label}><SelectPrimitive.Value /><ChevronDown size={14}/></SelectPrimitive.Trigger>
  <SelectPrimitive.Portal><SelectPrimitive.Positioner sideOffset={5} className="select-positioner"><SelectPrimitive.Popup className="select-popup">
   {options.map(option => <SelectPrimitive.Item key={option.value} value={option.value} disabled={option.disabled} className="select-item"><SelectPrimitive.ItemText>{option.label}</SelectPrimitive.ItemText><SelectPrimitive.ItemIndicator><Check size={14}/></SelectPrimitive.ItemIndicator></SelectPrimitive.Item>)}
  </SelectPrimitive.Popup></SelectPrimitive.Positioner></SelectPrimitive.Portal>
 </SelectPrimitive.Root>;
}
